const ClearHtml = (textHtml: string): string => {
	return textHtml.replace(/&nbsp;|<[^>]*>?/gm, '');
};

export default ClearHtml;
